import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Header.css";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMenuOpen && !event.target.closest('.header-nav') && !event.target.closest('.menu-toggle')) {
        closeMenu();
      }
    };

    // Close menu on escape key
    const handleEscape = (event) => {
      if (event.key === 'Escape' && isMenuOpen) {
        closeMenu();
      }
    };

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscape);
      // Prevent body scroll when menu is open on mobile
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  return (
    <header className="header">
      {/* Logo and Name on the Left */}
      <div className="header-left">
        <Link to="/" onClick={closeMenu}>
          <img src="/images/apco/Apco-logo.png" alt="Apco Lighting Logo" className="logo" />
        </Link>
      </div>

      {/* Hamburger Menu Button */}
      <button 
        className={`menu-toggle ${isMenuOpen ? 'active' : ''}`}
        onClick={toggleMenu}
        aria-label="Toggle menu"
        aria-expanded={isMenuOpen}
      >
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
      </button>

      {/* Navigation Links */}
      <nav className={`header-nav ${isMenuOpen ? "open" : ""}`}>
        <ul className="nav-list">
          <li><Link to="/" className="nav-link" onClick={closeMenu}>Home</Link></li>
          <li><Link to="/about" className="nav-link" onClick={closeMenu}>About Us</Link></li>
          <li><Link to="/products" className="nav-link" onClick={closeMenu}>Products</Link></li>
          <li><Link to="/contact" className="nav-link" onClick={closeMenu}>Contact Us</Link></li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;


